import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    requestTypes: [],
};

const getters = {
    getAllRequestTypes: (state) => state.requestTypes,
};

const mutations = {
    setAllRequestTypes(state, requestTypes) {
        state.requestTypes = requestTypes.slice();
    },
};

const actions = {
    async fetchAllRequestTypes({ commit }, status) {
        try {
            const response = await apolloClient.query({
                query: gql`
          query findAllRequestTypes($status: RequestTypeStatusEnum) {
            findAllRequestTypes(status: $status) {
              id
              name
              status
              creationDate
            }
          }
        `,
                variables: { status },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
                fetchPolicy: "network-only",
            });
            commit("setAllRequestTypes", response.data.findAllRequestTypes);
            return response.data.findAllRequestTypes;
        } catch (error) {
            console.error("Failed to fetch request types:", error);
            return [];
        }
    },

    async createRequestType({ dispatch }, requestTypeInput) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
          mutation createRequestType($requestTypeInput: RequestTypeInput!) {
            createRequestType(requestTypeInput: $requestTypeInput) {
              id
              name
            }
          }
        `,
                variables: { requestTypeInput },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
            });
            return response.data.createRequestType;
        } catch (error) {
            console.error("Failed to create request type:", error);
            return null;
        }
    },

    async updateRequestType({ dispatch }, { id, requestTypeInput }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
          mutation updateRequestType($id: Int!, $requestTypeInput: RequestTypeInput!) {
            updateRequestType(id: $id, requestTypeInput: $requestTypeInput) {
              id
              name
            }
          }
        `,
                variables: { id: +id, requestTypeInput },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
            });
            return response.data.updateRequestType;
        } catch (error) {
            console.error("Failed to update request type:", error);
            return null;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
